import { post } from "@/libs/http";
import { LoginWithPasswordReq, LoginWithPasswordRes } from "@/types/api/user-auth/login-with-password.d";
import { LoginWithCodeReq, LoginWithCodeRes } from "@/types/api/user-auth/login-with-code.d";
import { SendCodeReq, SendCodeRes } from "@/types/api/user-auth/send-code.d";
import { LogoutRes } from "@/types/api/user-auth/logout.d";
import { GuestLoginReq, GuestLoginRes } from "@/types/api/user-auth/guest-login.d";
import { ForgotPasswordResetReq, ForgotPasswordResetRes } from '@/types/api/user-auth/forgot-password-reset.d';
import { ForgotPasswordSendCodeReq, ForgotPasswordSendCodeRes } from "@/types/api/user-auth/forgot-password-send-code.d";
import { CompleteRegistrationReq, CompleteRegistrationRes } from "@/types/api/user-auth/complete-registration.d";
import { EmailBindReq, EmailBindRes } from "@/types/api/user-auth/email-bind.d";
import { EmailBindSendCodeReq, EmailBindSendCodeRes } from "@/types/api/user-auth/email-bind-send-code.d";
import { PhoneBindReq, PhoneBindRes } from "@/types/api/user-auth/phone-bind.d";
import { BindSendCodeReq, BindSendCodeRes } from "@/types/api/user-auth/bind-send-code.d";
import { BlackCheckReq, BlackCheckRes } from "@/types/api/user-auth/black-check.d";
import { Web3LoginReq, Web3LoginRes } from "@/types/api/user-auth/web3-login.d";
import { TelegramLoginReq, TelegramLoginRes } from "@/types/api/user-auth/telegram-login.d";
import { ThirdLoginReq, ThirdLoginRes } from "@/types/api/user-auth/third-login.d";
import { Oauth2AppLoginReq, Oauth2AppLoginRes } from "@/types/api/user-auth/oauth2-app-login.d";
import { RefreshReq, RefreshRes } from "@/types/api/user-auth/refresh.d";
import { createApiMutationHook } from "@/hooks/use-api-mutation";

// 密码登录
export const loginWithPassword = ({ params }: { params: LoginWithPasswordReq; }) => {
  return post<LoginWithPasswordRes>('/user/auth/v1/loginWithPassword', params);
};

// 验证码登录
export const loginWithCode = ({ params }: { params: LoginWithCodeReq; }) => {
  return post<LoginWithCodeRes>('/user/auth/v1/loginWithCode', params);
};

// 发送验证码
export const sendCode = ({ params }: { params: SendCodeReq; }) => {
  return post<SendCodeRes>('/user/auth/v1/sendCode', params);
};

// 游客登录
export const guestLogin = ({ params }: { params: GuestLoginReq; }) => {
  return post<GuestLoginRes>('/user/auth/v1/guest/login', params);
};

// 忘记密码-发送验证码
export const forgotPasswordSendCode = ({ params }: { params: ForgotPasswordSendCodeReq; }) => {
  return post<ForgotPasswordSendCodeRes>('/user/auth/v1/forgotPassword/sendCode', params);
};

// 忘记密码-重置密码
export const forgotPasswordReset = ({ params }: { params: ForgotPasswordResetReq; }) => {
  return post<ForgotPasswordResetRes>('/user/auth/v1/forgotPassword/reset', params);
};

// 完成注册
export const completeRegistration = ({ params }: { params: CompleteRegistrationReq; }) => {
  return post<CompleteRegistrationRes>('/user/auth/v1/completeRegistration', params);
};

// 绑定邮箱
export const emailBind = ({ params }: { params: EmailBindReq; }) => {
  return post<EmailBindRes>('/user/auth/v1/email/bind', params);
};

// 绑定邮箱-发送验证码
export const emailBindSendCode = ({ params }: { params: EmailBindSendCodeReq; }) => {
  return post<EmailBindSendCodeRes>('/user/auth/v1/email/bind/sendCode', params);
};

// 绑定手机
export const phoneBind = ({ params }: { params: PhoneBindReq; }) => {
  return post<PhoneBindRes>('/user/auth/v1/phone/bind', params);
};

// 绑定-发送验证码
export const bindSendCode = ({ params }: { params: BindSendCodeReq; }) => {
  return post<BindSendCodeRes>('/user/auth/v1/bindSendCode', params);
};

// 黑名单检查
export const blackCheck = ({ params }: { params: BlackCheckReq; }) => {
  return post<BlackCheckRes>('/user/auth/v1/blackCheck', params);
};

// Web3登录
export const web3Login = ({ params }: { params: Web3LoginReq; }) => {
  return post<Web3LoginRes>('/user/auth/v1/web3/login', params);
};

// Telegram登录
export const telegramLogin = ({ params }: { params: TelegramLoginReq; }) => {
  return post<TelegramLoginRes>('/user/auth/v1/telegram/login', params);
};

// 第三方登录
export const thirdLogin = ({ params }: { params: ThirdLoginReq; }) => {
  return post<ThirdLoginRes>('/user/auth/v1/third/login', params);
};

// OAuth2应用登录
export const oauth2AppLogin = ({ params }: { params: Oauth2AppLoginReq; }) => {
  return post<Oauth2AppLoginRes>('/user/auth/v1/oauth2/app/login', params);
};

// 刷新token
export const refresh = ({ params }: { params: RefreshReq; }) => {
  return post<RefreshRes>('/user/auth/v1/refresh', params);
};

// 退出登录
export const logout = () => {
  return post<LogoutRes>('/user/auth/v1/logout');
};



// ================ Hooks ================

// 密码登录的 Hook
export const useLoginWithPassword = createApiMutationHook(loginWithPassword);

// 验证码登录的 Hook
export const useLoginWithCode = createApiMutationHook(loginWithCode);

// 发送验证码的 Hook
export const useSendCode = createApiMutationHook(sendCode);

// 游客登录的 Hook
export const useGuestLogin = createApiMutationHook(guestLogin);

// 忘记密码-发送验证码的 Hook
export const useForgotPasswordSendCode = createApiMutationHook(forgotPasswordSendCode);

// 忘记密码-重置密码的 Hook
export const useForgotPasswordReset = createApiMutationHook(forgotPasswordReset);

// 完成注册的 Hook
export const useCompleteRegistration = createApiMutationHook(completeRegistration);

// 绑定邮箱的 Hook
export const useEmailBind = createApiMutationHook(emailBind);

// 绑定邮箱-发送验证码的 Hook
export const useEmailBindSendCode = createApiMutationHook(emailBindSendCode);

// 绑定手机的 Hook
export const usePhoneBind = createApiMutationHook(phoneBind);

// 绑定-发送验证码的 Hook
export const useBindSendCode = createApiMutationHook(bindSendCode);

// 黑名单检查的 Hook
export const useBlackCheck = createApiMutationHook(blackCheck);

// Web3登录的 Hook
export const useWeb3Login = createApiMutationHook(web3Login);

// Telegram登录的 Hook
export const useTelegramLogin = createApiMutationHook(telegramLogin);

// 第三方登录的 Hook
export const useThirdLogin = createApiMutationHook(thirdLogin);

// OAuth2应用登录的 Hook
export const useOAuth2AppLogin = createApiMutationHook(oauth2AppLogin);

// 刷新token的 Hook
export const useRefresh = createApiMutationHook(refresh);

// 退出登录的 Hook
export const useLogout = createApiMutationHook(logout);

